import { Helmet } from 'react-helmet-async';

import EmailConnectorCallbackManagerView from 'src/sections/auth/callbacks/email-connector-callback-view';


export default function EmailConnectorCallbackPage() {
  return (
    <>
      <Helmet>
        <title>JT: Complete Email Setup</title>
      </Helmet>

      <EmailConnectorCallbackManagerView />
    </>
  );
}
